import { render } from "./VerifyCheckIcon.vue?vue&type=template&id=b022c112"
const script = {}
script.render = render

export default script